<div style="margin: 0 1in" [ngClass]="{ 'report-loaded' : reportLoaded }">
  @for (questionGroup of report.questions; track questionGroup; let i = $index) {
    <div>
      <div class="question-row">
        @for (question of questionGroup; track question; let j = $index) {
          <div class="question-cell" [ngStyle]="{'flex-grow': question.flexGrow || 1}">
            <ng-template dynamic-component-loader [componentName]="question.type" [componentData]="question" [componentContext]="context" [formGroup]="ngForm" [flowComponent]="this"></ng-template>
          </div>
        }
      </div>
    </div>
  }
</div>